export function getWritingNclcFromScore(score: number) {
  if (score >= 393) return { nclc: "10+", cefr: "C1/C2" };
  if (score >= 371) return { nclc: "9", cefr: "C1" };
  if (score >= 349) return { nclc: "8", cefr: "B2" };
  if (score >= 310) return { nclc: "7", cefr: "B2" };
  if (score >= 271) return { nclc: "6", cefr: "B1" };
  if (score >= 226) return { nclc: "5", cefr: "B1" };
  if (score >= 181) return { nclc: "4", cefr: "A2" };
  return { nclc: "<4", cefr: "A1" };
}

export function normalizeWritingCorrection(raw: any) {
  const score = Number(
    raw?.totalScore ??
    raw?.score ??
    raw?.estimatedScore ??
    raw?.pontuacao ??
    raw?.pontuacaoEstimada ??
    raw?.result?.score ??
    raw?.metadata?.totalScore ??
    raw?.metadata?.score ??
    0
  ) || 0;

  const maxScore = Number(
    raw?.maxScore ??
    raw?.maximumScore ??
    raw?.result?.maxScore ??
    raw?.metadata?.maxScore ??
    450
  ) || 450;

  const level = getWritingNclcFromScore(score);

  const nclc =
    raw?.nclc ??
    raw?.nclcLevel ??
    raw?.niveauNCLC ??
    raw?.result?.nclc ??
    raw?.metadata?.nclc ??
    level.nclc;

  const cefr =
    raw?.cefr ??
    raw?.cefrLevel ??
    raw?.cecrl ??
    raw?.result?.cefr ??
    raw?.metadata?.cefr ??
    level.cefr;

  return {
    ...raw,
    score,
    totalScore: score,
    maxScore,
    nclc,
    cefr,
  };
}

export function resolveWritingScore(record: any): number | null {
  const value =
    record?.score ??
    record?.total_score ??
    record?.metadata?.totalScore ??
    record?.metadata?.score ??
    record?.metadata?.writingCorrection?.totalScore ??
    record?.metadata?.writingCorrection?.score ??
    null;

  const numeric = Number(value);
  return Number.isFinite(numeric) && numeric > 0 ? numeric : null;
}

export function resolveWritingMaxScore(record: any): number {
  return Number(
    record?.max_score ??
    record?.maxScore ??
    record?.metadata?.maxScore ??
    record?.metadata?.writingCorrection?.maxScore ??
    450
  ) || 450;
}

export function isWritingRecord(record: any): boolean {
  const competency = String(
    record?.competency ??
    record?.competence ??
    record?.skill ??
    ""
  ).toLowerCase();

  const section = String(record?.section ?? record?.task ?? "").toLowerCase();

  return (
    competency.includes("ee") ||
    competency.includes("expression écrite") ||
    competency.includes("expression ecrite") ||
    competency.includes("writing") ||
    section.includes("section a") ||
    section.includes("section b") ||
    section.includes("completo") ||
    section.includes("teste completo ee")
  );
}
